/**
 * Prefixa URLs internas do painel com /demo para navegação sem login.
 * Rotas públicas de marketing (/pages/*) permanecem sem prefixo.
 */
const DEMO_PREFIXABLE = [
  '/mobile',
  '/desktop',
  '/dispositivo',
  '/subscriptions',
  '/novo-dispositivo',
  '/transferir-licenca',
  '/transferir-dispositivos',
  '/conta/perfil'
]

export function shouldPrefixDemoUrl(url) {
  if (!url || typeof url !== 'string' || !url.startsWith('/')) return false
  if (url.startsWith('/pages/')) return false
  return DEMO_PREFIXABLE.some((p) => url.startsWith(p))
}

export function demoPrefixedPath(url, prefix) {
  if (!prefix || !shouldPrefixDemoUrl(url)) return url
  return prefix + url
}
